import { CONSTRUCTION_TYPE_ICONS } from 'assets/constructionTypeIcons';

import cn from 'classnames';

import styles from './ConstructionTypeIcon.module.css';

interface IConstructionTypeIcon {
    iconCode?: string | null;
    size?: number;
    className?: string;
}

export const ConstructionTypeIcon = ({ iconCode, size = 24, className }: IConstructionTypeIcon) => {
    const src = iconCode ? CONSTRUCTION_TYPE_ICONS[iconCode] : undefined;

    if (!src) {
        return null;
    }

    return <img src={src} alt="" width={size} height={size} className={cn(styles.icon, className)} />;
};

ConstructionTypeIcon.displayName = 'ConstructionTypeIcon';
